import { useDashQuery, useLazyDashQuery, useDashMutation } from 'legacy/apollo/clientHooks'

// Re-Export Base Apollo React Hooks
export * from '@apollo/react-hooks'

export const useQuery = useDashQuery
export const useLazyQuery = useLazyDashQuery
export const useMutation = useDashMutation
